import {
  isNotEmpty,
  isNotMaxLength,
  isAnEmail,
  isDateNotGreaterThanToday,
  isANumberGreaterThanZero,
  isANumberGreaterThanOrEqualZero,
} from "../../utils/validations.utils"
import { updateTeamMemberActiveStatus } from "../../services/teamMember.service"

export const TEAM_MEMBER_ACTION_MODAL_MESSAGES = {
  DISABLE_TEAM_MEMBER: {
    buildTitle: (displayName) =>
      displayName ?
        `Desactivar a ${displayName}`
      : "Desactivar integrante",
    description:
      "La información relacionada con este integrante, se mantendrá sin modificaciones. Sin embargo, ya no será parte de los reportes futuros.",
    service: updateTeamMemberActiveStatus,
  },
  ENABLE_TEAM_MEMBER: {
    buildTitle: (displayName) =>
      displayName ?
        `Habilitar a ${displayName}`
      : "Habilitar integrante",
    description:
      "La información de este integrante ahora será parte de los reportes futuros.",
    service: updateTeamMemberActiveStatus,
  },
}

export const TEAM_MEMBER_TABLE_DEFAULT_FILTER = {
  active: {
    value: 1,
    matchMode: "equals",
  },
}

export const FORM_TEAM_MEMBER_MODE = {
  CREATE: "create",
  EDIT: "edit",
}

export const FORM_TEAM_MEMBER_HOLIDAY_SCHEMAS_IDS_WITH_ACCORDED_DAYS = [3]

export const TEAM_MEMBER_INFO_FORM_INITIAL_DATA_STATE = {
  userFirstName: "",
  userLastName: "",
  userLastLogin: null,
  teamMemberNameTag: "",
  userAlias: "",
  userBirthday: null,
  userEmail: "",
  userPhone: "",
  teamMemberJobTitle: "",
  userWorkAnniversay: null,
  teamMemberIdArea: null,
  teamMemberIdHolidaySchema: null,
  teamMemberAccordedDays: 0,
}

export const TEAM_MEMBER_INFO_FORM_INITIAL_VALIDATION_STATE = {
  userFirstName: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  userLastName: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  teamMemberNameTag: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 3 } },
  },
  userAlias: {
    errors: [],
    value: null,
    typeValidations: [isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  userBirthday: {
    errors: [],
    value: null,
    typeValidations: [],
  },
  userEmail: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isAnEmail],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  userPhone: {
    errors: [],
    value: null,
    typeValidations: [],
  },
  teamMemberJobTitle: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isNotMaxLength],
    validationOptions: { isNotMaxLength: { max: 255 } },
  },
  userWorkAnniversay: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isDateNotGreaterThanToday],
  },
  teamMemberIdArea: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isANumberGreaterThanZero],
  },
  teamMemberIdHolidaySchema: {
    errors: [],
    value: null,
    typeValidations: [isNotEmpty, isANumberGreaterThanZero],
  },
  teamMemberAccordedDays: {
    errors: [],
    value: 1,
    typeValidations: [],
  },
}
